<table id="metadata" class="table table-striped table-hover table-responsive">
  <thead>
    <tr>
      <th scope="col">{{'item.edit.modify.overview.field'| translate}}</th>
      <th scope="col">{{'item.edit.modify.overview.value'| translate}}</th>
      <th scope="col">{{'item.edit.modify.overview.language'| translate}}</th>
    </tr>
  </thead>
  <tbody>
    @for (mdEntry of metadata | keyvalue; track mdEntry) {
      @for (mdValue of mdEntry.value; track mdValue) {
        <tr class="metadata-row">
          <td>{{mdEntry.key}}</td>
          <td>{{mdValue.value}}</td>
          <td>{{mdValue.language}}</td>
        </tr>
      }
    }
  </tbody>
</table>
